//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import { IProfessional } from 'src/app/shared/interfaces/professional/iprofessional';
import {
  deleteCurrentProfessional,
  editCurrentProfessional,
  editProfessional,
  editProfessionalError,
  editProfessionalSuccess,
  loadProfessional,
  loadProfessionalSuccess,
  resetProfessionalState,
  saveProfessional,
  saveProfessionalError,
  saveProfessionalSuccess
} from './professional.actions';


export interface IProfessionalState {
  lista: IProfessional[];
  currentProfessionalId: any;
  isLoading: boolean;
  isLoadingCreate: boolean;
  isUpdated: boolean;
  type: string | null;
  action: string;
  currentProfessional: any,
  error: any
}

const initialState: IProfessionalState = {
  lista: [],
  currentProfessionalId: null,
  isLoading: false,
  isLoadingCreate: false,
  isUpdated: false,
  type: null,
  action: "get",
  currentProfessional: null,
  error: null
};

export const professionalReducer = createReducer(
  initialState,
  on(loadProfessional, (state) => ({
    ...state,
    isLoading: true,
    type: "loading",
    action: "get",
  })),
  on(loadProfessionalSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false,
    type: "success",
    action: "get",
  })),
  on(editCurrentProfessional, (state, { professional }) => ({
    ...state,
    //currentProfessional: professional,
    //type: "loading",
    //action: "edit",
  })),
  on(saveProfessional, (state) => ({
    ...state,
    isLoadingCreate: true,
    type: "loading",
    action: "save",
  })),
  on(saveProfessionalSuccess, (state, { professional }) => ({
    ...state,
    isLoadingCreate: false,
    type: "success",
    action: "save",
    lista: [...state.lista, professional],
    currentProfessional: professional
  })),
  on(saveProfessionalError, (state, {error})=> ({
    ...state,
    type: "error",
    action: "save",
    error: error
  }) ),
  on(editProfessional, (state) => ({
    ...state,
    isLoadingCreate: true,
    type: "loading",
    action: "edit",
  })),
  on(editProfessionalSuccess, (state, { professional }) => ({
    ...state,
    isLoadingCreate: false,
    isUpdated: true,
    type: "success",
    action: "edit",
    lista: [...state.lista, professional],
    currentProfessional: professional
  })),

  on(editProfessionalError, (state) => ({
    ...state,
    type: "error",
    action: "edit",
  })),

  on(deleteCurrentProfessional, (state) => ({
    ...state,
    currentProfessional: null
  })),

  on(resetProfessionalState, (state) => ({
    ...state,
    type: null,
    action: 'get',
  }))

);
//colocar como parametro o professionalReducer lá no app.module
//agora criamos o selector em um novo arquivo
